/**
 * Ryan O'Dowd
 * 2025-12-06
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors, globalScale}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 4,
      backgroundColor: colors.alert,
    },
    text: {
      fontSize: globalScale * 12,
      color: colors.white,
    },
  };
};

export default getStyles;
